import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  Text,
  Icon,
  Box,
  useDisclosure,
} from "@chakra-ui/react";
import ArrowIcon from "@root/assets/icons/arrowicon";
import { IconCircle, StyledButton, StyledText } from "./style";
import { useTranslation } from "react-i18next";
export const LogoutModal: React.FC<LogoutModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation("common");
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="xl" p={4} bg="white" w="526px">
        <Flex direction="column" align="center" gap={4}>
          <IconCircle>
            <Icon as={ArrowIcon} boxSize={8} color="blue.600" />
          </IconCircle>
          {/* Title */}
          <Text fontSize="xl" fontWeight="bold">
            {t("logout.logout")}
          </Text>

          <StyledText>
            {t("logout.confirm")}
          </StyledText>
        </Flex>

        {/* Buttons */}
        <ModalFooter justifyContent="center" gap={4} mt={6}>
          <StyledButton bg="white" color="#1819B4" onClick={onClose}>
            {t("logout.cancel")}
          </StyledButton>
          <StyledButton bg="#40599B" onClick={onConfirm}>
            {t("logout.yesLogout")}
          </StyledButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
